import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const FloatingActionButton = ({ onAction }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  const getContextualActions = () => {
    switch (location?.pathname) {
      case '/guest-management':
        return [
          { label: 'Add Guest', icon: 'UserPlus', action: 'add-guest', primary: true },
          { label: 'Import Guests', icon: 'Upload', action: 'import-guests' },
        ];
      case '/dish-library':
        return [
          { label: 'Add Recipe', icon: 'Plus', action: 'add-recipe', primary: true },
          { label: 'Import Recipe', icon: 'Upload', action: 'import-recipe' },
        ];
      case '/dinner-planning':
        return [
          { label: 'New Event', icon: 'Calendar', action: 'new-event', primary: true },
          { label: 'Quick Plan', icon: 'Zap', action: 'quick-plan' },
        ];
      default:
        return [
          { label: 'New Event', icon: 'Calendar', action: 'new-event', primary: true },
          { label: 'Add Guest', icon: 'UserPlus', action: 'add-guest' },
          { label: 'Add Recipe', icon: 'Plus', action: 'add-recipe' },
        ];
    }
  };

  const actions = getContextualActions();
  const primaryAction = actions?.find(action => action?.primary) || actions?.[0];

  const handleActionClick = (actionType) => {
    setIsExpanded(false);
    if (onAction) {
      onAction(actionType);
    }
  };

  const handlePrimaryClick = () => {
    if (actions?.length === 1) {
      handleActionClick(primaryAction?.action);
    } else {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className="lg:hidden fixed bottom-6 right-6 z-50">
      {/* Backdrop */}
      {isExpanded && (
        <div
          className="fixed inset-0 bg-background/20 backdrop-blur-sm -z-10"
          onClick={() => setIsExpanded(false)}
        />
      )}
      {/* Action Menu */}
      {isExpanded && actions?.length > 1 && (
        <div className="absolute bottom-16 right-0 space-y-3 mb-2">
          {actions?.filter(action => !action?.primary)?.map((action, index) => (
            <div
              key={action?.action}
              className="flex items-center space-x-3 animate-in slide-in-from-bottom-2 fade-in-0"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <span className="bg-card text-foreground px-3 py-2 rounded-lg shadow-warm text-sm font-medium whitespace-nowrap">
                {action?.label}
              </span>
              <Button
                variant="secondary"
                size="icon"
                onClick={() => handleActionClick(action?.action)}
                className="w-12 h-12 rounded-full shadow-warm-md"
              >
                <Icon name={action?.icon} size={20} />
              </Button>
            </div>
          ))}
        </div>
      )}
      {/* Primary FAB */}
      <Button
        variant="default"
        size="icon"
        onClick={handlePrimaryClick}
        className={`w-14 h-14 rounded-full shadow-warm-lg transition-warm ${
          isExpanded ? 'rotate-45' : 'rotate-0'
        }`}
      >
        <Icon 
          name={isExpanded && actions?.length > 1 ? "Plus" : primaryAction?.icon} 
          size={24} 
        />
      </Button>
    </div>
  );
};

export default FloatingActionButton;